import dayjs from "dayjs";
import {
  LoaderFunction,
  redirect,
  useLoaderData,
  useNavigate,
} from "react-router-dom";

import { IfFlag } from "@/services/Flags";
import { get } from "api";
import ChevronLeft from "atoms/icon/icons/chevron_left.svg";
import TopNav from "molecules/navbars/TopNav";
import { queryClient } from "pages/Root";
import { formatCurrency } from "toolbox/Money";
import { waitObj } from "toolbox/Promise";

const load = async (transactionId: string) => {
  const repeatCashTransactions = queryClient.fetchQuery(
    ["/repeat-cash/transactions"],
    () => get("/repeat-cash/transactions")
  );
  const user = queryClient.fetchQuery(["/user"], () => get("/user"));
  const data = await waitObj({
    repeatCashTransactions,
    user,
  });
  const transaction = data.repeatCashTransactions.find(
    (i) => i.id === transactionId
  );

  return { transaction, user: data.user };
};

type LoaderData = Awaited<ReturnType<typeof load>>;
export const repeatCashActivityDetailsLoader: LoaderFunction = async ({
  params: { transactionId },
}) => {
  if (!transactionId) return redirect("..");
  return await load(transactionId);
};

export const RepeatCashActivityDetailsPage = () => {
  const { transaction, user } = useLoaderData() as LoaderData;
  const activity =
    transaction?.transactionType == "CashAdded" ? "Addition" : "Deduction";
  const activityPast =
    transaction?.transactionType == "CashAdded" ? "Added" : "Deducted";
  const navigate = useNavigate();

  return (
    <div className="relative h-full bg-one">
      <TopNav
        startIconSVG={ChevronLeft}
        showHeaderItems={false}
        onStartIconClick={() => navigate(-1)}
      >
        <div className="flex justify-center text-sub2">
          {activity.toUpperCase()} DETAILS
        </div>
      </TopNav>
      <div className="p-5">
        <div className="flex flex-col gap-5 rounded-lg bg-white px-7 py-6 shadow-subtle">
          <div className="flex flex-col gap-2 border-b-[1px] border-b-light-grey pb-5">
            <div className="mb-2 flex items-center gap-1 text-body2">
              <span className="text-bold1">Transaction:</span>
              {transaction?.id.split("-").pop()}
            </div>
            <div className="flex items-center gap-1 text-body2">
              <span className="text-bold2">Date: </span>
              {dayjs(transaction?.created).format("MM/DD/YY")}
            </div>
            <div className="flex items-center gap-1 text-body2">
              <span className="text-bold2">Location: </span>
              {user.platformLocation?.name}
            </div>
            <IfFlag equals={false} flag="enableRepeatCashAddition">
              <div className="flex items-center gap-1 text-body2">
                <span className="text-bold2">{activityPast} by: </span>
                {transaction?.createdBy?.fullName}
              </div>
            </IfFlag>
            <div className="flex items-center gap-1 text-body2">
              <span className="text-bold2">RepeatCash {activityPast}: </span>
              {transaction?.transactionType === "CashAdded" ? "" : "-"}
              {formatCurrency(transaction?.amount ?? 0)}
            </div>
          </div>
          <div className="flex flex-col gap-3">
            <div className="text-bold3 uppercase">{activity} Reason</div>
            <div className="text-body2">{transaction?.reason}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
